/* import __COLOCATED_TEMPLATE__ from './note-form.hbs'; */
import { action } from '@ember/object';
import { bannerError } from 'client-portal/utils/error-handling';
import { classNames } from '@ember-decorators/component';
import { dismissSticky, info } from 'client-portal/utils/banners';
import { ensureSafeComponent } from '@embroider/util';
import { importSync } from '@embroider/macros';
import { reads } from '@ember/object/computed';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './note-form.module.scss';

@classic
@classNames(styles.component)
export default class SiteDocumentsNoteForm extends Component {
  @service clientPortalTracking;
  @service currentPractice;
  @service intl;
  @service session;
  styles = styles;

  @reads('model.diagnosisTreatmentPlan.type') diagnosisTreatmentPlanType;
  @reads('model.diagnosisTreatmentPlan.structure.diagnoses') diagnoses;

  get diagnosisTreatmentPlanComponent() {
    let module = importSync(`./note/diagnosis-treatment-plan/${this.diagnosisTreatmentPlanType}`);
    return ensureSafeComponent(module.default, this);
  }

  didInsertElement() {
    super.didInsertElement();

    info({
      title: this.intl.t('messages.info.reviewDocumentAndSign'),
      isSticky: true,
      classNames: 'info-with-icon',
    });
  }

  willDestroyElement() {
    super.willDestroyElement(...arguments);
    dismissSticky();
  }

  @action
  async nextStep() {
    try {
      await this.completeRequestTask.perform(this.model);
    } catch (err) {
      let errorTitle = this.intl.t('messages.error.documentNotSubmitted');
      this.clientPortalTracking.trackErrorOnDocumentsPage(errorTitle);
      bannerError(err, { title: errorTitle });
    }
  }
}
